import {
    HiAtSymbol,
    HiOutlineCalendar,
    HiOutlineCheckCircle,
    HiOutlineDocumentText,
    HiOutlineHashtag,
    HiOutlineViewList,
} from 'react-icons/hi';
import { FieldTypeItem } from './page/common/type';

// Define field type options for form fields
export const TYPE_DEFINITIONS: FieldTypeItem[] = [
    {
        value: 'text',
        displayName: 'Text',
        Icon: HiOutlineDocumentText,
    },
    {
        value: 'email',
        displayName: 'Email',
        Icon: HiAtSymbol,
    },
    {
        value: 'enum',
        displayName: 'Multiple Choice',
        Icon: HiOutlineViewList,
    },
    {
        value: 'integer',
        displayName: 'Number',
        Icon: HiOutlineHashtag,
    },
    {
        value: 'boolean',
        displayName: 'Checkbox',
        Icon: HiOutlineCheckCircle,
    },
    {
        value: 'date',
        displayName: 'Date',
        Icon: HiOutlineCalendar,
    },
];
